import axios from "axios";

// Menyimpan promise yang sedang berjalan
const inFlightRequests = {};

// Cache di memori (singkat, agar saat transisi tidak hit API berulang)
const memoryCache = {};
const CACHE_TTL = 60 * 1000; // 1 menit

/**
 * fetchSharedData memastikan bahwa jika ada beberapa pemanggilan ke URL yang sama
 * secara bersamaan, hanya 1 request HTTP yang akan benar-benar dikirim.
 * Sisanya akan menunggu Promise yang sama.
 */
export const fetchSharedData = async (url) => {
  // 1. Cek apakah ada data di memory cache yang masih valid
  if (memoryCache[url] && Date.now() - memoryCache[url].timestamp < CACHE_TTL) {
    return memoryCache[url].data;
  }

  // 2. Cek apakah ada request yang sedang berjalan ke URL yang sama
  if (inFlightRequests[url]) {
    return inFlightRequests[url]; // Tunggu dan return hasil dari request yang sudah jalan
  }

  // 3. Jika tidak ada, buat request baru
  const requestPromise = axios
    .get(url)
    .then((response) => {
      // Simpan ke memory cache
      memoryCache[url] = {
        timestamp: Date.now(),
        data: response,
      };
      // Hapus dari inFlight agar request berikutnya bisa lewat cache
      delete inFlightRequests[url];
      return response;
    })
    .catch((error) => {
      // Hapus dari inFlight jika error, agar bisa dicoba lagi
      delete inFlightRequests[url];
      throw error;
    });

  // Daftarkan Promise ini agar pemanggil lain bisa ikut menunggu
  inFlightRequests[url] = requestPromise;

  return requestPromise;
};
